export type ActivityType = 'call' | 'meeting' | 'email' | 'note' | 'task';

export const ACTIVITY_TYPES: { value: ActivityType; label: string }[] = [
  { value: 'call', label: 'Call' },
  { value: 'meeting', label: 'Meeting' },
  { value: 'email', label: 'Email' },
  { value: 'note', label: 'Note' },
  { value: 'task', label: 'Task' },
];

export const ACTIVITY_TYPE_LABEL: Record<ActivityType, string> = Object.fromEntries(
  ACTIVITY_TYPES.map((t) => [t.value, t.label]),
) as Record<ActivityType, string>;
